import React, { useRef, useState } from 'react';

import styled from 'styled-components';

import { DropdownIcon } from '../Icons';
import MoreMenuWrapper from '../Modal/MoreMenuWrapper';

type stateType = 'default' | 'error';

type option = {
  value: string;
  label: string;
  iconURL?: string;
};

type Props = {
  state?: stateType;
  onChange?: () => void;
  label?: string;
  value?: string;
  options: option[];
  width?: number;
};

const Dropdown = ({ onChange, label, state = 'default', value, width, options }: Props) => {
  const targetButton = useRef();

  const handleClickOption = (option: option) => {
    onChange?.();
  };

  return (
    <SWrapper style={{ width }} $state={state}>
      <label>{label}</label>
      <div className="select-box" ref={targetButton}>
        <div className="value-box">
          <span>{value}</span>
        </div>
        <button className="arrow-button">
          <DropdownIcon size={20} />
        </button>
        <MoreMenuWrapper
          targetButton={targetButton}
          style={{
            position: 'absolute',
            top: 48,
            left: 0,
            width: '100%',
          }}
        >
          <SOptionList>
            {options.map((el) => (
              <li key={el.value} onClick={() => handleClickOption(el)}>
                {el.iconURL && <img src={el.iconURL} alt={el.label + '아이콘'} className="icon" />}
                {el.label}
              </li>
            ))}
          </SOptionList>
        </MoreMenuWrapper>
      </div>
    </SWrapper>
  );
};
export default Dropdown;

const SWrapper = styled.div<{ $state: stateType }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  label {
    color: ${({ theme }) => theme.color.text.TXT_3};
    ${({ theme }) => theme.font.body2_sb};
  }

  .select-box {
    position: relative;
    padding: 12px;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background: ${({ theme }) => theme.color.field.input};
    box-sizing: border-box;
    cursor: pointer;

    .value-box {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .icon {
      width: 24px;
      height: 24px;
    }

    span {
      color: ${({ theme }) => theme.color.text.TXT_3};
      ${({ theme }) => theme.font.body2_m};
    }
  }

  .arrow-button {
    width: 24px;
    height: 24px;
  }
`;

const SOptionList = styled.ul`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.line.line_1};
  background: ${({ theme }) => theme.color.static.white};
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

  li {
    display: flex;
    padding: 13px 8px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    cursor: pointer;

    .icon {
      width: 24px;
      height: 24px;
    }

    &:hover {
      background: ${({ theme }) => theme.color.buttons.hover};
    }
  }
`;
